import React from 'react'

const BooksPage = () => {
  return (
    <div>Books Page</div>
  )
}

export default BooksPage